<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="修改角色数据" name="1">
      <RoleAdd :updataID='updataID'></RoleAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import RoleAdd from '../../../../static/form/RoleAdd.vue'
export default {
  components: {
    RoleAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Rolegl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/RoleUpdate.vue